import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import ProjectAssetsSlider from './ProjectAssetsSlider';
import HomepageProjectsSlider from './HomepageProjectsSlider';

class Homepage extends React.Component {
    constructor(props) {
        super(props);
        
        // this.projectAssetsSliders = [];
        // this.homepageProjects = this.props.projects.filter(project => project.displayInMobileSlider);
        // this.homepageProjects.sort((a, b) => {
        //     if(a.homepageSliderOrder > b.homepageSliderOrder) {
        //         return 1;
        //     }
        //     else if(a.homepageSliderOrder < b.homepageSliderOrder) {
        //         return -1;
        //     }

        //     return 0;
        // });

        this.onProjectCredits = this.onProjectCredits.bind(this);
    }

    refreshProjectsList() {
        this.projectAssetsSliders = [];
        this.homepageProjects = this.props.projects.filter(project => project.displayInMobileSlider);
        this.homepageProjects.sort((a, b) => {
            if(a.homepageSliderOrder > b.homepageSliderOrder) {
                return 1;
            }
            else if(a.homepageSliderOrder < b.homepageSliderOrder) {
                return -1;
            }

            return 0;
        });
    }

    onProjectCredits(openingSliderCreditsIndex) {
        this.projectAssetsSliders.forEach((slider, index) => {
            if(index !== openingSliderCreditsIndex && slider.current) {
                slider.current.closeCredits();
            }
        });
    }

    render() {
        this.refreshProjectsList();

        return (
            <div>
                <Helmet>
                    <title>La Roulotte Retouche - Homepage</title>
                    <body class="home" />
                </Helmet>
                <div className="projects mobile">
                    {this.homepageProjects.map((project, index) => {
                        let ref = React.createRef();

                        this.projectAssetsSliders.push(ref);
                        console.log(this.projectAssetsSliders.length, this.homepageProjects.length);

                        return <ProjectAssetsSlider ref={ref} key={`${project.path}-assets-slider`} index={index} assets={project.sliderImages} details={project.details} onClickFn={this.onProjectCredits}/>;
                    })}
                </div>

                <HomepageProjectsSlider projects={this.homepageProjects}/>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        projects: state.assets.projects
    };
};

export default withRouter(connect(mapStateToProps, null)(Homepage));


// WEBPACK FOOTER //
// ./src/components/Homepage.js